import { render, staticRenderFns } from "./HeadsOfFleet.vue?vue&type=template&id=22f9855a"
import script from "./HeadsOfFleet.vue?vue&type=script&lang=js"
export * from "./HeadsOfFleet.vue?vue&type=script&lang=js"
import style0 from "./HeadsOfFleet.vue?vue&type=style&index=0&id=22f9855a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports